import { jsx as l } from "react/jsx-runtime";
import { getToneContentColorRole as s } from "../../../styles/colors/content/getToneContentColorRole.js";
import { getUtilityContentColorRole as d } from "../../../styles/colors/content/getUtilityContentColorRole.js";
import { iconNameMap as h } from "../../../styles/icons/icons.js";
import { iconSizeMap as u } from "./consts.js";
import "styled-components";
import { useThemeInMode as C } from "../../../context/theme/hooks.js";
function j({
  iconName: i,
  accessibilityLabel: o,
  size: m = "medium",
  tone: t,
  emphasis: r = "high",
  onHighEmphasisSurface: p = !1,
  utilityColor: e
}) {
  const n = C(), a = e ? n[d({
    utilityColor: e,
    emphasis: r
  })] : t ? n[s({
    tone: t,
    emphasis: r,
    onHighEmphasisSurface: p
  })] : "inherit", c = o ? { "aria-label": o } : { "aria-hidden": !0 }, f = h[i];
  return /* @__PURE__ */ l(
    f,
    {
      ...u[m],
      color: a,
      display: "block",
      ...c
    }
  );
}
export {
  j as default
};
